import { createFileRoute, notFound } from "@tanstack/react-router";

import { deviceTagsQueries } from "@/api/resources/deviceTags/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import { DeviceTagsPage } from "@/components/DeviceTag/DeviceTagsPage";
import i18n from "@/providers/i18n";
import { Icon } from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/tags/device-tags/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.tags-device-tags"),
        icon: <Icon.DEVICE_TAGS />,
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    await context.queryClient.ensureQueryData(deviceTagsQueries.listAll());
  },
  component: DeviceTagsPage,
});
